<template>
  <div class="discover-view">
    <DiscoverControl />
  </div>
</template>

<script setup lang="ts">
import DiscoverControl from '@/components/controls/DiscoverControl.vue'
</script>

<style lang="scss">
.discover-view {
  background-color: #fbfbfb;
  display: flex;
  justify-content: center;
  padding: 48px 24px;
  min-height: 100%;
}
</style>
